<template>
    <v-dialog v-model="dialog" max-width="800" @click:outside="hide">
        <v-card class="card-container">
            <v-card-text class="pa-10">
                <div class="body-message">
                    <div v-html="$t('payment.freemium_end_body')"/>
                </div>
                <div class="text-center mt-3">
                    <v-btn class="normal-btn" dark @click="goToChange">
                        {{ changeLabelButton }}
                    </v-btn>
                </div>
                <v-img class="logo" :src="require('@/assets/img/logo_header.png')" width="140" contain/>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: "FreemiumEndDialog",
    data() {
        return {
            dialog: false,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        changePaymentRoute(vm = this) {
            return `${vm.accountType}.payment.edit`
        },
        changePlanRoute(vm = this) {
            return `${vm.accountType}.select-plan`
        },
        changeLabelButton(vm = this) {
            if (vm.account?.stripeAccount?.paymentMethod) return vm.$t('common.change_plan')
            return vm.$t('common.change_card')
        }
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
        },
        goToChange() {
            const vm = this;
            if (vm.account?.stripeAccount?.paymentMethod) {
                vm.hide()
                vm.$router.push({ name: vm.changePlanRoute })
            }
            vm.hide()
            vm.$router.push({ name: vm.changePaymentRoute })
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.body-message {
    text-align: center;
}

.logo {
    position: absolute;
    bottom: 12px;
    right: 12px;
}

</style>